module.exports = __webpack_public_path__ + "img/clos-menu.29e1589d.svg";